export default class LoginState {
  constructor() {
    this.profile = {
      id: null,
      roleId: null,
    };
    this.login = {
      loading: false,
      error: null,
    };
    this.status = 'uninitialized';
    this.userUpdatePassword = {
      loading: false,
      data: {},
      error: null,
    };
    this.userLinkedinInfo = {
      loading: false,
      data: {},
      error: null,
    };
  }
}
